/**
 * The expected close date, and the default when none is set.
 *
 * ⭐⭐ JOSEPH'S RULING, 2026-08-27. Hold year 1 runs from the close, not from 1 January. The
 * lease engine was always built for this - its tests say "honours the close date, so the same
 * bump blends differently" - it simply never received one, so `InvestmentAnalysis.tsx`
 * hardcoded 1 January of the current year and every deal anchored on a year the buyer would
 * barely own.
 *
 * ⛔ 90 DAYS, AND IT IS STATED ON SCREEN, NEVER SILENT. A default that hides is an assumption
 * the reader cannot correct; the panel prints the date it used and the field is editable.
 */
export const DEFAULT_CLOSE_DAYS = 90;

/** ISO yyyy-mm-dd, UTC, so a date never shifts under a timezone. */
export const toIsoDate = (d: Date): string => d.toISOString().slice(0, 10);

/**
 * The close date to model against.
 * ⚠️ `today` is injected rather than read from the clock, so this is testable and so a
 * projection is reproducible from a stored analysis rather than drifting each time it opens.
 */
export const resolveCloseDate = (stored: string | null | undefined, today: Date): string => {
  const s = (stored ?? '').trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const d = new Date(today.getTime());
  d.setUTCDate(d.getUTCDate() + DEFAULT_CLOSE_DAYS);
  return toIsoDate(d);
};

/** True when the screen is falling back, so the UI can say so instead of implying a choice. */
export const isDefaultedCloseDate = (stored: string | null | undefined): boolean =>
  !/^\d{4}-\d{2}-\d{2}$/.test((stored ?? '').trim());
